import Vue from 'vue'
import { ActionContext, Module } from 'vuex'
import { ConversationProvider } from '../models/api/ConversationChannel'
import conversationChannelService from '../services/ConversationChannelService'
import { ConversationChannelsState, RootState } from './state_models'

export const conversationChannels: Module<ConversationChannelsState, RootState> = {
  namespaced: true,
  state: { customConversationChannels: [], defaultConversationChannels: {}},
  mutations: {
    addCustomChannels: (state: ConversationChannelsState, payload: ConversationProvider[]) => {
      Vue.set(state, 'customConversationChannels', payload)
    },

    addDefaultChannels: (state: ConversationChannelsState, payload: ConversationProvider[]) => {
      Vue.set(state, 'defaultConversationChannels', payload)
    }
  },
  actions: {
    fetchCustomChannels: {
      handler: async (context: ActionContext<ConversationChannelsState, RootState>, locationId: string) => {
        try {
          const res = await conversationChannelService.fetchCustomConversationChannels(locationId)
          const data = res?.conversationProviders || []
          context.commit('addCustomChannels', data)
        } catch(error) {
          console.log('Error fetching Custom Conversation Channels.', error)
        }
      }
    },

    fetchDefaultChannels: {
      handler: async (context: ActionContext<ConversationChannelsState, RootState>, locationId: string) => {
        try {
          const res = await conversationChannelService.fetchDefaultConversationChannels(locationId)
          const data = res?.defaultProviders || {}
          context.commit('addDefaultChannels', data)
          return data
        } catch(error) {
          console.log('Error fetching Default Conversation Channels.', error)
        }
      }
    },

    updateDefaultChannels: (context: ActionContext<ConversationChannelsState, RootState>, params: any) => {
      context.commit('addDefaultChannels', params)
    },
  }
}
